export default "__VITE_ASSET__BdpJF2Vv__"